import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  Notifications, NotificationTypes,
  NotificationKeyValue, UserNotifyActions, ApplicationNotifyActions, getNotificationActions
} from '../../../../core/models/notificationConfig';
import { UserService } from '../../../../core/services/user.service';

@Component({
  selector: 'app-notification-configuration',
  templateUrl: './notification-configuration.component.html',
  styleUrls: ['./notification-configuration.component.scss']
})
export class NotificationConfigurationComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<NotificationConfigurationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      userId: string
    },
    private userService: UserService,
    private snackBar: MatSnackBar
  ) { }

  notifications: NotificationTypes;
  emailNotification: { [key: string]: any } = {};
  portalNotification: Notifications;
  smsNotification: Notifications;
  notificationConfigForm: UntypedFormGroup;
  notificationKeyValueArray: any[] = [];
  notificationByKey: any[] = [];
  selectedNotificationConfiguration: any[] = [];
  selectedOptions: any[] = [];
  selectedNotificationCategory: string;

  ngOnInit(): void {
    this.notificationConfigForm = new UntypedFormGroup({
      notificationsTypes: new UntypedFormControl("emailNotification"),
      notificationsKey: new UntypedFormControl(),
      notificationsToChoose: new UntypedFormControl()
    })

    this.getNotificationConfiguration(this.data.userId);

    this.notificationKeyValueArray = Object.keys(NotificationKeyValue).map(key => {
      return { key, value: NotificationKeyValue[key] };
    });

    this.notificationConfigForm.controls['notificationsKey'].setValue(this.notificationKeyValueArray ? this.notificationKeyValueArray[0] : null);
  }

  onClose() {
    this.dialog.close(false);
  }

  getNotificationConfiguration(userName) {
    this.userService.getNotificationConfigForUser(userName)
      .subscribe({
        next: (data: any) => {
          if (data) {
            if (data?.data) {
              this.notifications = <NotificationTypes>JSON.parse(JSON.stringify(data?.data));
              if (!this.notifications) {
                this.dialog.close(false);
              }
              this.analyzeNotifications(this.notifications);
            }
          }
        },
        error: (err) => {
          this.snackBar.open("Something went wrong.", "Ok", { duration: 3000 });
          this.dialog.close();
        }
      })
  }

  updateNotifyConfig() {
    this.userService.updateNotificationConfiguration(this.notifications, this.data.userId)
      .subscribe({
        next: (data: any) => {
          this.dialog.close(true);
          this.snackBar.open(data.actionMessage, "Ok", { duration: 3000 });
        },
        error: (err) => {
          this.dialog.close(true);
          this.snackBar.open(err.error?.actionMessage, "Ok", { duration: 3000 });
        }
      })
  }

  optionClicked(value: string) {
    this.notificationByKey = [];
    this.selectedOptions = [];
    this.selectedNotificationCategory = value;

    const item = this.notificationKeyValueArray.find(item => item.key == value);
    let userInput = "userNotification"; // Change this to the user's input
    if (item) {
      userInput = item.value;
    }
    this.notificationByKey = getNotificationActions(userInput);

    if (this.emailNotification) {
      if (this.emailNotification[value]) {
        Object.keys(this.emailNotification[value]).forEach(ele => {
          if (this.emailNotification[value][ele]) {
            this.selectedOptions.push(this.notificationByKey.find(item => item.key === ele))
          }
        })
      }
    }
    this.notificationConfigForm.controls['notificationsToChoose'].setValue(this.selectedOptions);
  }

  analyzeNotifications(data) {
    for (const channel of Object.keys(data)) {
      const channelData = data[channel];

      switch (channel.toLowerCase()) {
        case "emailnotifications":
          this.emailNotification = channelData;
          break;

        case "portalnotifications":
          this.portalNotification = channelData;
          break;

        case "smsnotifications":
          this.smsNotification = channelData;
          break;
      }
    }
  }

  onSelectionChange(event: MatSelectChange) {
    const selectedNotifications = event.value; // An array of selected notifications

    if (selectedNotifications && selectedNotifications?.length > 0) {
      if (this.notificationByKey) {
        Object.keys(this.notificationByKey).forEach(ele => {
          const key = this.notificationByKey[ele].key;
          const keyExists = selectedNotifications.some(item => item.key === key);
          if (keyExists) {
            this.emailNotification[this.selectedNotificationCategory][key] = true;
          }
          else {
            this.emailNotification[this.selectedNotificationCategory][key] = false;
          }
        })
      }
    }
    else {
      for (const category in this.emailNotification) {
        if (category.toLowerCase() == this.selectedNotificationCategory.toLowerCase()) {
          for (const key in this.emailNotification[category]) {
            this.emailNotification[category][key] = false;
          }
        }
      }
    }
  }
}
